import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=4fba11c3&scoped=true&"
import script from "./ProductsView.vue?vue&type=script&lang=js&"
export * from "./ProductsView.vue?vue&type=script&lang=js&"
import style0 from "./ProductsView.vue?vue&type=style&index=0&id=4fba11c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fba11c3",
  null
  
)

export default component.exports